var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "div",
        {
          staticClass:
            "mx-auto p-1 sm:px-4 sm:pt-20 sm:w-11/12 md:w-3/4 lg:w-1/2 xl:w-1/2"
        },
        [
          _c(
            "debug-bar",
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "danger", size: "sm", square: "" },
                  on: { click: _vm.populateForm }
                },
                [_vm._v("Popular")]
              ),
              _c(
                "b-form-checkbox",
                {
                  model: {
                    value: _vm.showIds,
                    callback: function($$v) {
                      _vm.showIds = $$v
                    },
                    expression: "showIds"
                  }
                },
                [_c("span", { staticClass: "text-danger" }, [_vm._v("Visão")])]
              ),
              _c(
                "div",
                {
                  staticClass: "cursor-pointer hover:text-danger font-bold",
                  on: { click: _vm.previousStep }
                },
                [_vm._v(" " + _vm._s("<") + " ")]
              ),
              _c("div", [_vm._v(" " + _vm._s(_vm.step) + " ")]),
              _c(
                "div",
                {
                  staticClass: "cursor-pointer hover:text-danger font-bold",
                  on: { click: _vm.nextStep }
                },
                [_vm._v(" " + _vm._s(">") + " ")]
              )
            ],
            1
          ),
          _vm.onCover
            ? _c(
                "b-card",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "footer",
                        fn: function() {
                          return [_c("form-footer")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4079284371
                  )
                },
                [
                  _c("due-diligence-cover", {
                    attrs: { "legal-entity": this.legalEntity }
                  }),
                  _c("hr"),
                  _c(
                    "b-form-checkbox",
                    {
                      model: {
                        value: _vm.awareTruth,
                        callback: function($$v) {
                          _vm.awareTruth = $$v
                        },
                        expression: "awareTruth"
                      }
                    },
                    [
                      _vm._v(
                        " Declaro estar ciente de que todas as informações e documentos inseridos são verdadeiros, completos e precisos. "
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex justify-end" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: !_vm.awareTruth,
                            variant: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.step = "form"
                            }
                          }
                        },
                        [_vm._v("Continuar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.onForm
            ? _c(
                "b-card",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "footer",
                        fn: function() {
                          return [_c("form-footer")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4079284371
                  )
                },
                [
                  _c("due-diligence-title", { staticClass: "pb-2" }),
                  _c("hr"),
                  _c("formula", {
                    ref: "formula",
                    staticClass: "pb-2",
                    attrs: {
                      debug: _vm.showIds,
                      "form-definition": _vm.formDefinition
                    },
                    on: { mounted: _vm.formulaMounted },
                    model: {
                      value: _vm.data,
                      callback: function($$v) {
                        _vm.data = $$v
                      },
                      expression: "data"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "flex justify-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: { variant: "primary" },
                          on: { click: _vm.submit }
                        },
                        [_vm._v("Enviar")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function($event) {
                              _vm.step = "cover"
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.onConfirm
            ? _c(
                "b-card",
                {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "footer",
                        fn: function() {
                          return [_c("form-footer")]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    false,
                    4079284371
                  )
                },
                [
                  _c("due-diligence-title", { staticClass: "pb-2" }),
                  _c("formula", {
                    ref: "formula",
                    staticClass: "pb-2",
                    attrs: {
                      debug: _vm.showIds,
                      "view-only": "",
                      "form-definition": _vm.formDefinition
                    },
                    on: { mounted: _vm.formulaMounted },
                    model: {
                      value: _vm.data,
                      callback: function($$v) {
                        _vm.data = $$v
                      },
                      expression: "data"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "mb-1" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "font-bold",
                          model: {
                            value: _vm.confirmed,
                            callback: function($$v) {
                              _vm.confirmed = $$v
                            },
                            expression: "confirmed"
                          }
                        },
                        [
                          _vm._v(
                            "Confirmo que todos os dados acimas estão corretos"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "flex justify-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            disabled: !_vm.confirmed,
                            variant: "primary"
                          },
                          on: { click: _vm.confirm }
                        },
                        [_vm._v("Confirmar")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "float-right",
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function($event) {
                              _vm.step = "form"
                            }
                          }
                        },
                        [_vm._v("Voltar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }